module.exports = __webpack_public_path__ + "static/media/sablon.3094eef0.png";